<template>
  <div class="payment-operation">
    <div v-if="paySuccess" class="pay-success">
      <slot>
        <div class="flex-align">
          <span class="pay-success-fee text-bold">{{ fee }} 元</span>
          <span
            class="text-success pay-success-status"
          >（ {{ payStatusLabel }} ）</span>
        </div>
        <money-in-cn class="m-t-4" :money="fee" />
      </slot>
      <div class="m-t-10">
        如需开具发票，请前往个人中心的费用账单申请开具发票
        <el-button type="text" @click="toPersonCenter">立即前往>></el-button>
      </div>
    </div>
    <div
      v-else-if="!onlyButton"
      class="pay-inbox flex-align__between"
      :class="{ 'no-bottom-border-radius': isBorderRadius }"
      @click="goPay"
    >
      <div>
        <div class="flex">
          <strong class="pay-money">{{ fee }}元</strong>
          <span class="text-warning">（{{ payStatusLabel }}）</span>
        </div>
        <money-in-cn class="m-t-4" :money="fee" />
      </div>
      <el-button type="primary" class="pay-btn">{{ btnText }}</el-button>
    </div>
    <el-button v-else type="primary" class="pay-btn" @click="goPay">
      {{ btnText }}
    </el-button>

    <pay-result-dialog
      v-model="payResultDialogVisible"
      :order-code="orderCode"
      :pay-no="payNo"
      :result-api="resultApi"
      @getResult="getResult"
      @toPayCenter="toPayCenter"
    />
  </div>
</template>

<script>
import PayResultDialog from '@/components/common/PayResultDialog'
import MoneyInCn from '@/components/common/MoneyInCn'

import { paymentStatusDict } from '@/dictionary/project/common'
export default {
  name: 'PaymentOperation',

  components: {
    PayResultDialog,
    MoneyInCn
  },

  props: {
    // 支付单号
    payNo: {
      type: String,
      default: ''
    },

    // 业务单号
    orderCode: {
      type: String,
      default: ''
    },

    // 查询支付结果接口
    resultApi: {
      type: Function,
      required: true
    },

    // 支付时间
    fee: {
      type: [String, Number],
      default: ''
    },

    // 支付状态
    payStatusLabel: {
      type: String,
      default: ''
    },

    // 支付成功
    paySuccess: {
      type: Boolean,
      default: false
    },

    // 只展示按钮
    onlyButton: {
      type: Boolean,
      default: false
    },

    // 支付按钮文字
    btnText: {
      type: String,
      default: '前往支付'
    },

    // 样式下边框是否有border
    isBorderRadius: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      payResultDialogVisible: false,
      paymentStatusDict
    }
  },

  methods: {
    goPay() {
      if (this.payNo) {
        // 直接前往支付中心
        this.toPayCenter(this.payNo)
      } else {
        // 先下单
        this.$emit('getPayInfo')
      }
    },

    // 跳转支付中心
    toPayCenter(payNo) {
      const paymentUrl = `${process.env.VUE_APP_PAY_URL}/order/${payNo ||
        this.payNo}`
      window.open(paymentUrl, '_blank')
      this.payResultDialogVisible = true
    },

    getResult(result) {
      this.$emit('getResult', result)
    },

    // 前往个人中心的支付账单
    toPersonCenter() {
      const url = `${
        process.env.VUE_APP_PASSPORT_URL
      }/personal-center/expense-billing?returnUrl=${encodeURIComponent(
        window.location.href
      )}`
      window.open(url, '_self')
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-success {
  color: $third-text-color;
  font-size: pixel-to-rem($n: 14);
  ::v-deep .el-button {
    padding: 0;
  }
}
.pay-inbox {
  background-color: $primary-fourth-color;
  padding: 16px 24px;
  width: 520px;
  border-radius: 4px;
  cursor: pointer;
  .pay-money {
    font-size: 24px;
    color: $text-color;
  }
}
.pay-success-fee {
  font-size: 24px;
  color: $text-color;
}
.pay-success-status {
  font-size: 14px;
}
.no-bottom-border-radius {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>
